import { Component, OnInit } from '@angular/core';
import { OnBoardingService } from '../../services/on-boarding.service';
import { BackgroundProcessService } from '../../services/background-process.service';
import { Platform, MenuController } from '@ionic/angular';
@Component({
  selector: 'smr-menu-button',
  templateUrl: './smr-menu-button.component.html',
  styleUrls: ['./smr-menu-button.component.scss'],
})
export class MenuButtonComponent implements OnInit {
  public bookingRequestCount: number = 0;

  public bookingWaitListCount: number = 0;

  public isMobile: boolean = false;

  constructor(
    public onBoardingService: OnBoardingService,
    public menuCtrl: MenuController,
    private backgroundProcessService: BackgroundProcessService,
    public platform: Platform
  ) {
    this.backgroundProcessService.bookingRequestMonitor$.subscribe(
      (bookingRequestCount: number) => {
        this.bookingRequestCount = bookingRequestCount;
      }
    );

    this.backgroundProcessService.bookingWaitListMonitor$.subscribe(
      (bookingWaitListCount: number) => {
        this.bookingWaitListCount = bookingWaitListCount;
      }
    );
  }

  ngOnInit() {
    this.platform.ready().then(() => {
      if (
        this.platform.is('mobile') ||
        this.platform.is('android') ||
        this.platform.is('iphone') ||
        this.platform.is('mobileweb')
      ) {
        this.isMobile = true;
      }
    });
  }

  async openMenu() {
    await this.menuCtrl.enable(true);
    this.menuCtrl.toggle();
  }
}
